import { render, staticRenderFns } from "./reserveFund.vue?vue&type=template&id=010097f7&scoped=true"
import script from "./reserveFund.vue?vue&type=script&lang=js"
export * from "./reserveFund.vue?vue&type=script&lang=js"
import style0 from "./reserveFund.vue?vue&type=style&index=0&id=010097f7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010097f7",
  null
  
)

export default component.exports